<template>
  <div>


    <h3 class="mt-3 mb-4 mk-fe-businesscustomers">Customer Details</h3>

    <hr />

    <div class="row" v-for="(customer, index) in initial_business.users" :key="index">
      <div class="col-12">
        <h6>{{customer.full_name}}</h6>
      </div>


      <div class="col-6">
        <p>Phone</p>
      </div>
      <div class="col-6">{{customer.phone_number}}</div>


      <div class="col-6">
        <p>Email</p>
      </div>
      <div class="col-6">{{customer.email}}</div>


      <div class="col-6">
        <p>DOB</p>
      </div>
      <div
        class="col-6"
      >{{customer.date_of_birth ? moment.utc(customer.date_of_birth, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss') : 'N/A'}}</div>
    </div>


  </div>
</template>
<script>
export default {
  props: {
    initial_business: Object
  },
  data() {
    return {
      //
    };
  }
};
</script>